import React from 'react';
import i18n from '@i18n';
import './wrapper.less';
import { ArrowsWrapper, ArrowsWrappedSwipeableViews } from '@/responsive/components/ArrowsWrapper/ArrowsWrapper';

export const WrappersBody = ({
    children,
    title = null,
    headerLink = null,
    headerLinkDisabled = false,
    footerLink = null,
    footerLinkDisabled = false,
    headerClassName = '',
    className = '',
    arrows
}) => (
    <div className={`home-module-wrapper ${className}`}>
        {(title || headerLink || arrows) && (
            <div className={`home-module-wrapper-header ${headerClassName}`}>
                <div className="home-module-wrapper-subheader">
                    {title && <h3 className="home-module-wrapper-title">{title}</h3>}
                    {headerLink && (
                        <span
                            className={`home-module-wrapper-link ${headerLinkDisabled ? 'disabled' : ''}`}
                            onClick={headerLink}
                        >
                            {i18n('common.terms.all')}
                        </span>
                    )}
                </div>
                {arrows}
            </div>
        )}
        {children}
        {footerLink && (
            <div className="home-module-wrapper-footer">
                <span
                    className={`home-module-wrapper-link ${footerLinkDisabled ? 'disabled' : ''}`}
                    onClick={footerLink}
                >
                    {i18n('common.show.all')}
                </span>
            </div>
        )}
    </div>
);

const Wrapper = ({
    children,
    title = null,
    headerLink = null,
    headerLinkDisabled = false,
    footerLink = null,
    footerLinkDisabled = false,
    onLeftClick = null,
    leftDisabled = false,
    onRightClick = null,
    rightDisabled = false,
    headerClassName = '',
    className = ''
}) => (
    <ArrowsWrapper
        onLeftClick={onLeftClick}
        leftDisabled={leftDisabled}
        onRightClick={onRightClick}
        rightDisabled={rightDisabled}
    >
        {arrows => (
            <WrappersBody
                title={title}
                headerLink={headerLink}
                headerLinkDisabled={headerLinkDisabled}
                footerLink={footerLink}
                footerLinkDisabled={footerLinkDisabled}
                headerClassName={headerClassName}
                className={className}
                arrows={arrows}
            >
                {children}
            </WrappersBody>
        )}
    </ArrowsWrapper>
);

const EMPTY_OBJECT = {};

export const WrappedSwipeableViews = ({
    collection,
    apertureSize,
    children,
    title = null,
    whenEmpty = null,
    headerLink = null,
    headerLinkDisabled = false,
    footerLink = null,
    footerLinkDisabled = false,
    swipeableProps = EMPTY_OBJECT,
    className = ''
}) =>
    !collection.length && whenEmpty ? (
        <ArrowsWrapper leftDisabled rightDisabled>
            {arrows => (
                <WrappersBody
                    title={title}
                    headerLink={headerLink}
                    headerLinkDisabled={headerLinkDisabled}
                    footerLink={footerLink}
                    footerLinkDisabled={footerLinkDisabled}
                    className={className}
                    arrows={arrows}
                >
                    {whenEmpty()}
                </WrappersBody>
            )}
        </ArrowsWrapper>
    ) : (
        <ArrowsWrappedSwipeableViews collection={collection} apertureSize={apertureSize}>
            {(arrows, Swipeable, index, rest, ref) => (
                <WrappersBody
                    title={title}
                    headerLink={headerLink}
                    headerLinkDisabled={headerLinkDisabled}
                    footerLink={footerLink}
                    footerLinkDisabled={footerLinkDisabled}
                    className={className}
                    arrows={arrows}
                >
                    <div ref={ref} style={{ paddingRight: rest }} className="swipeable-padder">
                        <Swipeable index={index} className="swipeable-container" {...swipeableProps}>
                            {children}
                        </Swipeable>
                    </div>
                </WrappersBody>
            )}
        </ArrowsWrappedSwipeableViews>
    );

export default Wrapper;
